import type { ReactNode } from "react";
import AppHeader from "@/components/feature/AppHeader";
import BottomNav from "@/components/feature/BottomNav";

type AppShellProps = {
  children: ReactNode;
  headerVariant?: "onDark" | "onLight";
  showSearch?: boolean;
  showBack?: boolean;
};

export default function AppShell({ children, headerVariant = "onDark", showSearch = false, showBack = false }: AppShellProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <AppHeader variant={headerVariant} showSearch={showSearch} showBack={showBack} />
      {/* pb- extra para que el contenido nunca quede tapado detrás del BottomNav,
          que ahora es "fixed" (clavado a la pantalla) en vez de "sticky". */}
      <main className="flex-1 vv-safe-x pb-[calc(6rem+env(safe-area-inset-bottom))]">
        {children}
      </main>
      <BottomNav />
    </div>
  );
}
